import React from 'react';
import { Car, Eye, TrendingUp, MessageSquare } from 'lucide-react';

const StatsCards = ({ stats }) => {
  const cards = [
    { 
      icon: Car, 
      color: 'text-[#DC2626]', 
      value: stats?.total_vehicles || 0, 
      label: 'Total véhicules' 
    },
    { 
      icon: Eye, 
      color: 'text-green-500', 
      value: stats?.available_vehicles || 0, 
      label: 'Disponibles' 
    },
    { 
      icon: TrendingUp, 
      color: 'text-blue-500', 
      value: stats?.sold_vehicles || 0, 
      label: 'Vendus' 
    },
    { 
      icon: MessageSquare, 
      color: 'text-yellow-500', 
      value: stats?.unread_contacts || 0, 
      label: 'Messages non lus' 
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {cards.map((card, index) => (
        <div key={`stat-${index}`} className="stats-card">
          <card.icon className={`mx-auto ${card.color} mb-2`} size={32} />
          <p className="text-3xl font-bold text-gray-900">{card.value}</p>
          <p className="text-gray-500">{card.label}</p>
        </div>
      ))}
    </div>
  );
};

export default StatsCards;
